/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";

import type { FC } from "react";

export const LiveCommerceAddressNoRegister: FC<{
  isDarkModeEnabled: boolean;
}> = ({ isDarkModeEnabled }) => {
  const { t } = useI18n();

  return (
    <div
      css={css`
        display: grid;
        grid-template-columns: 1fr max-content;
        align-items: center;
        gap: 16px;
        min-height: 104px;
        padding: 16px;
        color: ${isDarkModeEnabled ? "#fff" : "#000"};
        background-color: ${isDarkModeEnabled ? "#141414" : "#f5f5f5"};
        border: 1px solid;
        border-color: ${isDarkModeEnabled
          ? "rgba(255, 255, 255, 0.2)"
          : "#e0e0e0"};
      `}
    >
      <p
        css={css`
          color: #ff0000;
          font-size: 14px;
        `}
      >
        {t("streaming.commerceCart.emptyAddressMessage")}
      </p>

      <p
        css={css`
          color: ${isDarkModeEnabled ? "#fff" : "#000"};
          font-size: 14px;
          cursor: pointer;
        `}
      >
        {t("streaming.commerceCart.register")}
      </p>
    </div>
  );
};
